module.exports = __webpack_public_path__ + "img/user-vipon.cd417ae8.svg";